import Referee from './referee';
import './referee.scss';

export default Referee;